import { LOCALES } from 'utils/languageUtils';

/** @type {Readonly<Record<LOCALES.ENGLISH | LOCALES.GREEK, Record<string, string>>>} */
const ROAMING_NETWORK_INFO_LABELS = Object.freeze({
  [LOCALES.ENGLISH]: {
    servicesTitle: 'Available Services',
    networkVoice: 'Voice/SMS',
    network4G: '4G',
    network5G: '5G+',

    networkVoiceTitle: 'Voice',
    networkVoiceDesc: 'Direct from Telekom, Greece’s largest mobile operator. Secure, reliable.',
    network4GTitle: '4G',
    network4GDesc: 'Direct from Telekom, Greece’s largest mobile operator. Secure, reliable.',
    network5GTitle: '5G+',
    network5GDesc: 'Direct from Telekom, Greece’s largest mobile operator. Secure, reliable.',

    providersTitle: 'Provider Information',

    chargeTitle: 'Basic Charges',
    chargesInfoIncomingTitle: 'Incoming (€/minute)',
    chargesInfoOutgoingTitle: 'Outgoing (€/minute)',
    chargesInfoSmsTitle: 'SMS. (€/SMS)',
    chargesInfoDataTitle: 'Data. (€/MB)',
  },
  [LOCALES.GREEK]: {
    servicesTitle: 'Διαθέσιμες υπηρεσίες',
    networkVoice: 'Φωνή/SMS',
    network4G: '4G',
    network5G: '5G+',
    providersTitle: 'Πληροφορίες παρόχων',

    networkVoiceTitle: 'Φωνή',
    networkVoiceDesc: 'Απευθείας από την Telekom, τον μεγαλύτερο πάροχο κινητής τηλεφωνίας στην Ελλάδα. Ασφαλές, αξιόπιστο.',
    network4GTitle: '4G',
    network4GDesc: 'Απευθείας από την Telekom, τον μεγαλύτερο πάροχο κινητής τηλεφωνίας στην Ελλάδα. Ασφαλές, αξιόπιστο.',
    network5GTitle: '5G+',
    network5GDesc: 'Απευθείας από την Telekom, τον μεγαλύτερο πάροχο κινητής τηλεφωνίας στην Ελλάδα. Ασφαλές, αξιόπιστο.',

    chargeTitle: 'Βασικές χρεώσεις',
    chargesInfoIncomingTitle: 'Εισερχ. (€/λεπτό)',
    chargesInfoOutgoingTitle: 'Εξερχ. (€/λεπτό)',
    chargesInfoSmsTitle: 'SMS. (€/SMS)',
    chargesInfoDataTitle: 'Data. (€/MB)',
  },
});
export default ROAMING_NETWORK_INFO_LABELS;
